/*
  Actions to toggle, hide and show any togglable item
*/
const toggle = name => ({ type: `TOGGLE_${name.toUpperCase()}` });
const show = name => ({ type: `SHOW_${name.toUpperCase()}` });
const hide = name => ({ type: `HIDE_${name.toUpperCase()}` });

export { toggle, show, hide };
